/**
 * Thi công resource cho màn danh sách tài sản
 */
export default {
  Title: 'Đã kết nối MISA QLTS',
  MappingSource: 'Đối chiếu nguồn',
  FAVoucherIncreament: 'Ghi tăng TSCĐ',
  FAVoucherDecrement: 'Ghi giảm TSCĐ',
  FAVoucherAdjustment: 'Điều chỉnh TSCĐ',
  FAVoucherDepreciation: 'Tính hao mòn TSCĐ',
  FAVoucherDepreciationTab: 'Hao mòn TSCĐ',
  DepreciationYear: 'Năm tính HM',
  DepreciationYearTooltip: 'Năm tính hao mòn',
  Asset: 'Tài sản',
  Mapping: {
    Content:
      'Vui lòng chọn các nguồn trên danh mục nguồn kinh phí tương ứng với nguồn đã được khai báo trên MISA QLTS để việc lấy dữ liệu hạch toán được chính xác.',
    Action: 'Thực hiện',
    ActionTooltip: 'Thực hiện (Ctrl + S)',
  },
  DisconnectQLTS: {
    Title: 'Ngừng kết nối MISA QLTS',
    Content:
      'Chức năng này cho phép <span class="color-green">ngừng kết nối</span> phần mềm MISA Bamboo Online với MISA QLTS. </br> </br>' +
      'Để theo dõi chi tiết TSCĐ trên MISA Bamboo, cần phải thực hiện lần lượt các thao tác sau: </br>' +
      '1. Khai báo danh sách TSCĐ </br>' +
      '2. Cập nhật lại các chứng từ phát sinh chi tiết theo từng TSCĐ </br> </br>' +
      'Bạn có chắc chắn muốn ngừng kết nối với MISA QLTS không? </br>',
    Disconnect: 'Ngừng kết nối',
    None: 'Không',
  },
  Process: {
    Title: 'Tài sản cố định',
    Increament: 'Ghi tăng',
    Decrement: 'Ghi giảm',
    Adjustment: 'Điều chỉnh',
    Depreciation: 'Tính hao mòn',
    Ledger: 'Sổ tài sản cố định',
    LedgerConectQLTS: 'Sổ kế toán',
    Disconnect: 'Ngắt kết nối',
    Connecting: 'Đang kết nối',
    MisaQLTS: 'MISA QLTS',
    AddFixedAsset: 'Khai báo tài sản cố định',
    Department: 'Phòng ban',
    Connect: 'Kết nối',
    DisConnecting: 'Đã ngắt kết nối',
    BoughtQLTS: 'Đơn vị đã mua phần mềm',
    ConectToPosted: 'Thực hiện kết nối để tự động hạch toán',
    Register: 'Đăng ký sử dụng',
    VoucherTab: 'Danh sách chứng từ TSCĐ',
    LearnMore: 'Tìm hiểu thêm',
    FeatureQLTS: 'Với nhiều tính năng ưu việt',
    MajorQLTS: 'Đầy đủ nghiệp vụ QLTS',
    RegulationQLTS: 'Đầy đủ quy định QLTS',
    ConectBambooNow: 'Kết nối Misa Bamboo Online để hạch toán',
  },
  Fieldset: {
    DepreciationInfo: 'Thông tin hao mòn',
    OtherInfo: 'Thông tin khác',
    Cost: 'Nguyên giá',
    CostAdjust: 'Nguyên giá điều chỉnh',
    DepreciationRate: 'Tỷ lệ hao mòn',
    DepreciationRateYear: 'Tỷ lệ hao mòn năm',
    AccumulatedDepreciation: 'Hao mòn lũy kế',
    AccumulatedDepreciationAdjust: 'HMLK điều chỉnh',
    AccumulatedDepreciationAdjustTooltip: 'Hao mòn lũy kế điều chỉnh',
    DepreciationValue: 'Giá trị HM năm',
    DepreciationValueTooltip: 'Giá trị hao mòn năm',
    TimeUsed: 'Thời gian sử dụng',
    TimeUsedLast: 'Thời gian SD còn lại (năm)',
    TimeUsedLastTooltip: 'Thời gian sử dụng còn lại (năm)',
    Year: 'Năm',
    LastValue: 'Giá trị còn lại',
    OrgPriceAccount: 'TK nguyên giá',
    OrgPriceAccountTooltip: 'Tài khoản nguyên giá',
    DepreciationAccount: 'TK hao mòn',
    DepreciationAccountTooltip: 'Tài khoản hao mòn',
    SourceAccount: 'TK nguồn',
    SourceAccountTooltip: 'Tài khoản nguồn',
    Department: 'Phòng ban',
    Type: 'Phân loại',
    Status: 'Tình trạng',
    ToYear: 'Đến năm',
  },
};
